module.exports = __webpack_public_path__ + "img/pagina menu correios entrar.085bd057.png";